import React from "react";
import { PATH_FAQ } from "../utils/constants";
import { FAQSection } from "../components/common/FAQSection";
import { JsonLd } from "../components/common/JsonLd";
import { RelatedPages } from "../components/common/RelatedPages";
import { FAQData } from "../types/faq";
import faqs from "../data/faqs.json";
import { SEOHelmet } from "../components/common/SEOHelmet";
import { buildFaqPageGraph } from "../utils/structured-data";

export default function FAQsPage() {
  const faqData = faqs as FAQData;

  return (
    <>
      <SEOHelmet page="faqs" pathname={PATH_FAQ} />
      <JsonLd data={buildFaqPageGraph(faqData)} />
      <main className="relative isolate overflow-hidden">
        <FAQSection faqs={faqData.faqs} />
        <RelatedPages pathname={PATH_FAQ} />
      </main>
    </>
  );
}
